import Axios from "axios";

export const fetchWalletBalance = ({ mobileNumber }) =>
  Axios.post(
    `${process.env.REACT_APP_DIRECTUS_INSTANCE_PATH}self-serve/qa/details/gift-card`,
    {
      phone_number: mobileNumber,
      dataKeys: ["walletBalance"],
    },
    {
      withCredentials: true,
    },
  );

export const fetchGiftCardBalance = ({ cardNumber }) =>
  Axios.post(
    `${process.env.REACT_APP_DIRECTUS_INSTANCE_PATH}self-serve/qa/details/gift-card`,
    {
      card_number: cardNumber,
      dataKeys: ["cardStatus", "cardCurrencySymbol", "amount"],
    },
    {
      withCredentials: true,
    },
  );
